module.exports = __webpack_public_path__ + "static/media/swingBottomImg3.f831ecc1.png";